import { MemoriesPage } from '@features/memories/components/MemoriesPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_shell/memories')({ component: MemoriesPage });
